import { render, staticRenderFns } from "./CreateContentMerma.vue?vue&type=template&id=3ff2f354&scoped=true"
import script from "./CreateContentMerma.vue?vue&type=script&lang=js"
export * from "./CreateContentMerma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2f354",
  null
  
)

export default component.exports